import $ from "jquery";
import { storeToken } from "./loginState";

export function handleGoogleAuth(credentialResponse, isSignup = true, onLoadingStart, onLoadingEnd, loginState, navigate, setIsGoogleSigninError) {
  const googleAuthEndPoint = process.env.REACT_APP_GOOGLE_AUTH_ENDPOINT;
  
  // Show loading spinner
  if (onLoadingStart) onLoadingStart();
  
  // Decode and log the token payload for debugging
  try {
    const payload = JSON.parse(atob(credentialResponse.credential.split('.')[1]));
  } catch (e) {
    console.error("Failed to decode token:", e);
  }
  
  $.ajax({
    url: googleAuthEndPoint,
    type: 'POST',
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: JSON.stringify({ idTokenString: credentialResponse.credential }),
    success: (data) => {
      const payload = JSON.parse(atob(credentialResponse.credential.split('.')[1]));
      localStorage.setItem("userEmail", payload.email);
      storeToken(data);
      
      // Use proper React Router navigation and login state management
      if (loginState && navigate) {
        loginState.setLoggedIn(true);
        navigate("/mockInterviewerInput");
      } else {
        // Fallback to window.location.replace if props not available
        window.location.replace("/mockInterviewerInput");
      }
    },
    error: (xhr, status, error) => {
      // Hide loading spinner on error
      if (onLoadingEnd) onLoadingEnd();
      
      // Show Google signin error
      if (setIsGoogleSigninError) {
        setIsGoogleSigninError("true");
        document.getElementById("googleSigninError").style.display = "block";
        document.getElementById("wrongCredentials").style.display = "none";
        document.getElementById("invalidSignUp").style.display = "none";
        document.getElementById("userSessionExpired").style.display = "none";
      }
    }
  });
}

export function onSignInGoogle(credentialResponse) {
  handleGoogleAuth(credentialResponse, true);
}

export function onLoginInGoogle(credentialResponse) {
  handleGoogleAuth(credentialResponse, false);
}
